import _objectWithoutProperties from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import 'intersection-observer';
import { createReporter } from './reporter';
import { createDirective } from './directive';
import BossReporter from './middleware/boss-report';
var reporter;
export function useReporter() {
  return reporter;
}

function createGlobalApi(Vue, reporter) {
  // eslint-disable-next-line
  Vue.prototype.$report = reporter;
}
/**
 * @type {VftReport.ReportPluginObject}
 */


var plugin = {
  install: function install(Vue, options) {
    var _options$middlewares = options.middlewares,
        middlewares = _options$middlewares === void 0 ? [] : _options$middlewares,
        params = _objectWithoutProperties(options, ["middlewares"]);

    middlewares.unshift(new BossReporter(params));
    reporter = createReporter(params, middlewares);
    createDirective(Vue, middlewares);
    createGlobalApi(Vue, reporter);
  }
};
export default plugin;